import { gql } from '@apollo/client';
import { client } from './client';

export const updateUserInfo = async (payload) => {
  const param = {
    input: payload,
  };
  const results = await client.mutate({
    mutation: gql`
    mutation UserProfileMutation($input: JSON!){
      userProfile(input: $input){
        login{
            id
            email
            firstName
            lastName
            username
            timezone
            profileImage {
              key
              resolutions
              status
              cropPosition
            }
          }
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return results;
};

export const checkUsername = async (payload) => {
  const param = {
    input: payload,
  };
  const results = await client.mutate({
    mutation: gql`
    mutation CheckUsername($input: String!){
      checkUsername(input: $input){
        isUsernameExisted
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return results.data.checkUsername.isUsernameExisted;
};

export const checkEmail = async (payload) => {
  const param = {
    email: payload,
  };
  const results = await client.query({
    query: gql`
    query checkEmail($email: String!){
      checkEmail(email: $email){
        isEmailExisted
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return results.data.checkEmail.isEmailExisted;
};

export const getNotificationPreferences = async () => {
  const results = await client.query({
    query: gql`
      query {
        notificationPreferences {
          defaultEmailBatch {
            id
            kind
            sendDelay
            days
            daySendTime
            daySendTz
            sendAt
          }
          prefs
        }
      }
    `,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return results.data;
};

export const saveNotificationPreferences = async ({
  prefs,
  defaultEmailBatch,
}) => {
  const param = {
    input: {
      prefs,
      default_email_batch: {
        day_send_time: defaultEmailBatch.daySendTime,
        day_send_tz: defaultEmailBatch.daySendTz,
        send_delay: defaultEmailBatch.sendDelay,
        kind: defaultEmailBatch.kind,
      },
    },
  };
  const results = await client.mutate({
    mutation: gql`
      mutation updateNotificationPreferences($input: JSON) {
        updateNotificationPreferences(input: $input) {
          notificationPreferences {
            id
            sendPersonalizedSummary
            sendInspirations
            sendPartners
            defaultEmailBatch {
              id
              kind
              sendDelay
              days
              daySendTime
              daySendTz
              sendAt
            }
            prefs
          }
        }
      }
    `,
    variables: param,
  });

  return results.data;
};

export const updateLoginSavedColors = async (input) => {
  const results = await client.mutate({
    mutation: gql`
      mutation updateLoginColorPreferences($input: JSONString!) {
        updateLoginColorPreferences(input: $input) {
          savedColors
        }
      }
    `,
    variables: { input },
    errorPolicy: 'all',
  });

  return results.data;
};

export const getIntegrationAuthenticationUrl = async (variables) => {
  const param = {
    input: variables,
  };
  const results = await client.mutate({
    mutation: gql`
      mutation generateIntegrationAuthUrl($input: IntegrationGrantsInput) {
        generateIntegrationAuthUrl(input: $input) {
          authUrl
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });

  return results;
};

export const createIntegrationVCalGrant = async (email = null) => {
  const param = { email };
  const results = await client.mutate({
    mutation: gql`
      mutation createIntegrationVcalGrant($email: String) {
        createIntegrationVcalGrant(email: $email) {
          integration{
            id
            email
            provider
            loginCalendars{
              id
              integrationId
              calendarType
              name
            }
          }
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });
  return results;
};

export const deleteIntegrationAccount = async (id) => {
  const param = { id };
  const results = await client.mutate({
    mutation: gql`
      mutation deleteIntegrationAccount($id: Int!) {
        deleteIntegrationAccount(id: $id) {
          isDeleted
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });

  return results;
};

export const createLoginCalendar = async (variables) => {
  const param = {
    input: variables,
  };
  const results = await client.mutate({
    mutation: gql`
      mutation createLoginCalendar($input: CreateLoginCalendarInput!) {
        createLoginCalendar(input: $input) {
          loginCalendar{
            id
            integrationId
            calendarType
            name
          }
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });

  return results;
};

export const deleteLoginCalendar = async (id) => {
  const param = { id };
  const results = await client.mutate({
    mutation: gql`
      mutation deleteLoginCalendar($id: Int!) {
        deleteLoginCalendar(id: $id) {
          loginCalendar{
            id
            integrationId
          }
          isDeleted
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });

  return results;
};
